interface NewPostsIconProps {
  size?: number;
  className?: string;
}

const NewPostsIcon: React.FC<NewPostsIconProps> = ({ size = 16, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <g className="newPostsFlySheet">
        <rect
          x="1.75"
          y="1.75"
          width="12.5"
          height="12.5"
          rx="2.5"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.75"
        />
        <path
          d="M4.75 6.4H8.5M4.75 8.9H11"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          opacity="0.75"
        />
      </g>
      <rect
        x="1.75"
        y="1.75"
        width="12.5"
        height="12.5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <path
        d="M4.75 5.5H8M4.75 8H11.25M4.75 10.5H10"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <circle cx="11.6" cy="4.6" r="1" fill="currentColor" />
    </svg>
  );
};

export default NewPostsIcon;
